// removed by extract-text-webpack-plugin
module.exports = {"component":"_1HkB9velPA6u8VvffE8bwH","remove":"_1LHRUKv1O6Z3mN0fkWjJfM","img":"_1rIaVaBlo8a1YLjv0WxTHO","big":"CJRpiyukPLXFaHkW_n5hv","txt":"Xr36berz7jRFV25r2uMas","span":"_3_tYKhJ3deD3PLgFTQY_kA","mr0":"j-JBXp5e-UjJPqG_m1nuA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AttentionArtworkComponent/AttentionArtworkComponent.scss
 ** module id = 948
 ** module chunks = 0
 **/